import FixaSSRIcon from "@coworker/apprestructured/src/shared/wrappers/FixaSSRIcon/FixaSSRIcon";
import CheckmarkCircleIconPath from "@coworker/apprestructured/src/shared/wrappers/FixaSSRIcon/paths/CheckmarkCircleIconPath";
import CrossCircleIconPath from "@coworker/apprestructured/src/shared/wrappers/FixaSSRIcon/paths/CrossCircleIconPath";
import styles from "./StatusBadge.module.css";

type StatusBadgeVariant = "positive" | "negative";

type StatusBadgeProps = {
  variant: StatusBadgeVariant;
  children: React.ReactNode;
};

function StatusBadge({ variant, children }: StatusBadgeProps) {
  const iconPath =
    variant === "positive" ? CheckmarkCircleIconPath : CrossCircleIconPath;

  return (
    <div className={styles["root"]}>
      <FixaSSRIcon paths={iconPath} className={styles[variant]} />
      <span className={styles[variant]}>{children}</span>
    </div>
  );
}

export default StatusBadge;
